
import React from 'react';

const ProblemItem: React.FC<{ icon: string; title: string; children: React.ReactNode }> = ({ icon, title, children }) => (
  <li className="flex items-start space-x-4">
    <div className="flex-shrink-0">
      <div className="bg-jskool-blue/10 text-jskool-blue rounded-full w-12 h-12 flex items-center justify-center">
        <span className="text-2xl font-bold">{icon}</span>
      </div>
    </div>
    <div>
      <h4 className="font-heading font-bold text-xl text-jskool-dark">{title}</h4>
      <p className="text-jskool-dark/70 mt-1">{children}</p>
    </div>
  </li>
);

const WhyJSkoolSection: React.FC = () => {
  return (
    <section id="whyjskool" className="py-20 bg-white">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-heading font-extrabold text-jskool-dark">Why JSkool?</h2>
          <p className="mt-4 text-lg text-jskool-dark/70 max-w-3xl mx-auto">
            Addressing the real-world challenges of modern Jain families.
          </p>
        </div>
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          <div>
            <img
              src="https://images.unsplash.com/photo-1588072432836-e10032774350?q=80&w=800&auto=format&fit=crop"
              alt="Family learning together on a tablet"
              className="rounded-2xl shadow-2xl"
            />
          </div>
          <div className="text-left">
            <h3 className="text-3xl font-heading font-bold text-jskool-dark mb-6">Pathshala at Your Fingertips</h3>
            <ul className="space-y-6">
              <ProblemItem icon="🌍" title="Accessibility Barriers">
                Traditional Pathshalas are not available everywhere, especially in metro cities where families often relocate for work. JSkool breaks down geographical barriers.
              </ProblemItem>
              <ProblemItem icon="⏳" title="For Busy Parents">
                With both parents often working, time and energy are precious. We eliminate the stress of travel and scheduling, empowering parents to teach Jain values at their convenience.
              </ProblemItem>
              <ProblemItem icon="💡" title="Bridging the Resource Gap">
                Not everyone has access to the resources or manpower to run a Pathshala. We bring a high-quality, standardized curriculum to everyone, regardless of location.
              </ProblemItem>
              <ProblemItem icon="🤝" title="Uniting All Traditions">
                We believe all Jains are one family. Our platform is inclusive of all sub-sects, providing a unified and comprehensive approach to learning that transcends traditional divisions.
              </ProblemItem>
            </ul>
            <p className="mt-8 text-lg text-jskool-dark/80 font-semibold">
              JSkool bridges these gaps through a synergy of community and technology, making sacred teachings accessible to anyone and everyone eager to incorporate the universal values of Jainism into their lives.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyJSkoolSection;